import * as net from 'util/Net';

import {ProcessTaskDefinitionGraphQL} from '../../../graphql-fragments/processes/__generated/ProcessTaskDefinitionGraphQL';
import {ProcessTaskDefinitionVersionGraphQL} from '../../../graphql-fragments/processes/__generated/ProcessTaskDefinitionVersionGraphQL';
import {CreateProcessTaskSchemaRequest} from './ProcessSchemaDAO';

type CreateProcessTaskDefinitionVersionSpec = {
  applicationData: any; // oxlint-disable-line @typescript-eslint/no-explicit-any
} & (
  | {
      taskSchemaId: string;
    }
  | {
      taskSchemaSpec: CreateProcessTaskSchemaRequest;
    }
);

export interface CreateProcessTaskDefinitionRequest {
  name: string;
  organizationId: string;
  firstVersion: CreateProcessTaskDefinitionVersionSpec;
}

export function createProcessTaskDefinition(
  data: CreateProcessTaskDefinitionRequest
): Promise<ProcessTaskDefinitionGraphQL> {
  return net.postJSONPromise({
    url: '/1/api/process-task-definitions',
    data,
  });
}

export type CreateProcessTaskDefinitionVersionRequest = {
  taskDefinitionId: string;
} & CreateProcessTaskDefinitionVersionSpec;

export function createProcessTaskDefinitionVersion(
  data: CreateProcessTaskDefinitionVersionRequest
): Promise<ProcessTaskDefinitionVersionGraphQL> {
  return net.postJSONPromise({
    url: '/1/api/process-task-definition-versions',
    data,
  });
}
